export class Payment {
  token: string;
  amount: number;
  rateLimit: number;
  totalCredits: number;
  currency: string;
  clientMail: string;
  clientId: string;
  userId: string;
  crmId: string;
  status: string;
}
